import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BizcoverIndiaFigmaHeader } from "../../components/marketing/BizcoverIndiaFigmaHeader";

/**
 * Standalone preview for the Figma BizcoverIndia header (node 22430:5083).
 * Does not replace the live site header — visit `/figma-header-preview`.
 */
export default function BizcoverIndiaFigmaHeaderPreview() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");

  useEffect(() => {
    const id = "dm-sans-figma-header";
    if (document.getElementById(id)) return;
    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,600;1,9..40,400&display=swap";
    document.head.appendChild(link);
  }, []);

  const handleSearch = () => {
    const trimmed = q.trim();
    if (trimmed) {
      navigate(`/search?q=${encodeURIComponent(trimmed)}`);
    } else {
      navigate("/search");
    }
  };

  return (
    <div className="min-h-screen bg-[#f4f6f8]">
      <BizcoverIndiaFigmaHeader
        searchQuery={q}
        onSearchChange={setQ}
        onSearchSubmit={handleSearch}
        onExploreCategoriesClick={() => navigate("/categories")}
      />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center text-sm text-[#637381]">
        <p className="font-['DM_Sans',sans-serif]">
          This page only previews the Figma header. Your homepage and dashboards still use the existing
          header.
        </p>
      </div>
    </div>
  );
}
